import { cn } from "@omni/utils/styles";

import { StoreSearchFilter } from "./storeSearchFilter/storeSearchFilter.component";

type StoreSearchFiltersComponentProps = {
    storeFeatures: Array<string>;
    activeSearchFilters: Array<string>;
    onToggleStoreSearchFilter: (feature: string) => void;
};

const StoreSearchFiltersComponent = ({
    storeFeatures,
    activeSearchFilters,
    onToggleStoreSearchFilter
}: StoreSearchFiltersComponentProps) => {
    return (
        <ul
            className={cn(
                "tw:flex tw:flex-col tw:px-2 tw:max-h-full tw:overflow-auto tw:m-0"
            )}
        >
            {storeFeatures.map((storeFeature) => (
                <StoreSearchFilter
                    key={storeFeature}
                    storeFeature={storeFeature}
                    active={activeSearchFilters.includes(storeFeature)}
                    onToggle={onToggleStoreSearchFilter}
                />
            ))}
        </ul>
    );
};

export { StoreSearchFiltersComponent };
